<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="开始时间">
          <Col span="12">
            <DatePicker
              type="date"
              @on-change="table.search.begintime = $event"
              v-model="table.search.begintime"
              placeholder="选择开始时间"
            ></DatePicker>
          </Col>
        </FormItem>
        <FormItem label="结束时间">
          <Col span="12">
            <DatePicker
              type="date"
              @on-change="table.search.endtime = $event"
              v-model="table.search.endtime"
              placeholder="选择结束时间"
            ></DatePicker>
          </Col>
        </FormItem>
      </Form>
      <div>
          <Button class="mr-3" type="success" @click="search">查询</Button>
          <Button class="mr-3" type="primary" @click="exportExcel">导出</Button>
      </div>
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
    ></DataTable>
  </div>
</template>
<script>
import DataTable from "@/components/NoPageDataTable.vue";

export default {
  components: { DataTable },
  data: function () {
    return {
      EmailSendFlagSelect: [],
      currentData: {},
      detailModal: false,
      table: {
        columns: [
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "检查类型", key: "examTypeName" },
          { title: "医院编号", key: "examOrganCode" },
          { title: "医院名称", key: "organName" },
          { title: "数量", key: "num" },
        ],
        apiUrl: "datastatistics/getStatisticsByHosptialExamTypeList",
        search: {
          ExamOrganCode: "",
          begintime: "",
          endtime: "",
        },
      },
    };
  },

  created: function () {
    this.clientLogTypeSelect = this.$common.getJsonData("clientLogType");
    let organCode = localStorage.getItem("organCode");
    let userType = localStorage.getItem("userType");
    if (!userType.indexOf("管理员")) {
      this.table.search.ExamOrganCode = organCode;
    }
  },
  activated(){
    this.search()
  },
  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    exportExcel: function () {
      var urls ="/"+ this.table.apiUrl + "exportExcel?";
      let baseUrl = localStorage.getItem("baseURL");
      const Qs = require("qs");
      let params = Qs.stringify(this.table.search);
      let url = baseUrl + urls + params;
      console.log(url);
      window.open(url);
    },
    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = data;
    },
  },
};
</script>
<style scoped>
</style>